
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightBulb as ObiLightBulbElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-bulb.js';
 
 
 

 
 export const ObiLightBulb = createComponent({
   react: React,
   tagName: 'obi-light-bulb',
   elementClass: ObiLightBulbElement,
   events: {
     
   }
  });
 
 